import { createIntl, createIntlCache } from 'react-intl';
import translations from '~/infra/i18n/locales';
import { getLocale } from '~/utils/getLocale';
import { SendClinicalDocs } from '~/domain/usecases/clinicalDocs/remote';
import {
  InvalidCredentialsError,
  UnexpectedError,
  BadRequestError,
  NotFound,
} from '~/domain/errors';
import { HttpClient, HttpStatusCode } from '~/data/protocols/http';
import '~/infra/global/variables';
import { AlertMessage } from '~/presentation/components/messages/AlertMessage';

const cache = createIntlCache();

const intl = createIntl(
  {
    locale: String(getLocale()),
    messages: translations[getLocale()],
  },
  cache,
);

export class RemoteSendClinicalDocs implements SendClinicalDocs {
  private readonly url: string;

  private readonly httpClient: HttpClient<SendClinicalDocs.Model>;

  constructor(url: string, httClient: HttpClient<SendClinicalDocs.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  post = async (
    params: SendClinicalDocs.Params,
  ): Promise<SendClinicalDocs.Model> => {
    console.log('params: ', params);
    const httpResponse = await this.httpClient.request({
      url: `${this.url}/${params.docId}/email`,
      method: 'post',
      body: {
        to: params.email,
      },
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.noContent:
        AlertMessage({
          message: intl.formatMessage({ id: 'Documento enviado com sucesso!' }),
          type: 'success',
        });
        return httpResponse.body;
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  };
}
